import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
            
            <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
              <p className="text-sm text-gray-500 mb-8">Last updated: January 2025</p>
              
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p>By accessing and using our gaming marketplace platform, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
                <p>Our platform provides a digital marketplace for gaming products, including but not limited to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Digital game keys and licenses</li>
                  <li>In-game currency and virtual items</li>
                  <li>Gaming subscriptions and memberships</li>
                  <li>Gift cards and digital vouchers</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. User Accounts</h2>
                <p>To access certain features of our service, you must create an account. You agree to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide accurate and complete information</li>
                  <li>Maintain the security of your account credentials</li>
                  <li>Accept responsibility for all activities under your account</li>
                  <li>Notify us immediately of any unauthorized use</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Purchases and Payments</h2>
                <p>When making purchases through our platform:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>All prices are displayed in the currency specified</li>
                  <li>Payment is due immediately upon order placement</li>
                  <li>We accept various payment methods as indicated at checkout</li>
                  <li>Digital products are delivered electronically after payment confirmation</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Digital Product Delivery</h2>
                <p>Digital products are typically delivered within minutes of purchase confirmation. Delivery may be delayed due to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Payment verification processes</li>
                  <li>Technical issues or maintenance</li>
                  <li>Security reviews for fraud prevention</li>
                  <li>Supplier availability</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Refunds and Returns</h2>
                <p>Due to the digital nature of our products, refunds are limited to specific circumstances:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Product key is invalid or already used</li>
                  <li>Wrong product delivered</li>
                  <li>Technical issues preventing activation</li>
                  <li>Refund requested before product key is revealed (within 14 days)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Prohibited Uses</h2>
                <p>You may not use our service to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Engage in fraudulent or illegal activities</li>
                  <li>Resell products without authorization</li>
                  <li>Attempt to circumvent security measures</li>
                  <li>Use automated systems to make purchases</li>
                  <li>Violate intellectual property rights</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Intellectual Property</h2>
                <p>All content on our platform, including text, graphics, logos, and software, is protected by intellectual property laws and remains the property of their respective owners.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Limitation of Liability</h2>
                <p>To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our service.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Privacy</h2>
                <p>Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the service, to understand our practices.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Modifications</h2>
                <p>We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of the service constitutes acceptance of the modified terms.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Termination</h2>
                <p>We may terminate or suspend your account and access to our service at our sole discretion, without prior notice, for conduct that we believe violates these terms or is harmful to other users.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Governing Law</h2>
                <p>These terms shall be governed by and construed in accordance with the laws of the jurisdiction in which our company is incorporated.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">14. Contact Information</h2>
                <p>If you have any questions about these Terms of Service, please contact us at:</p>
                <div className="bg-gray-50 p-4 rounded-lg mt-4">
                  <p><strong>Email:</strong> legal@gamestore.com</p>
                  <p><strong>Address:</strong> 123 Gaming Street, Digital City, DC 12345</p>
                  <p><strong>Phone:</strong> +1 (555) 123-4567</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
